import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { useGroupContext } from '../Group/GroupContext.js';
import { Icon } from '../Icon/Icon.js';
import { DotsLoader } from '../Loader/Dots/Dots.js';
import { RadialLoader as RadialLoaderMemoized } from '../Loader/Radial/Radial.js';
import { Typography } from '../Typography/Typography.js';
import { mapLeadingIcon, mapTrailingIcon, mapLabelCaption, mapLabelVariant, mapIconVariant, mapContainerBox, defaultProps } from './Button.mappers.js';

/** Button allows users to take actions, and make choices, with a single interaction. */
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var isUnderGroup = useGroupContext();
  var leadingIconProps = mapLeadingIcon(props);
  var leadingIconElement = React.useMemo(function () {
    return leadingIconProps && /*#__PURE__*/React.createElement(Icon, leadingIconProps);
  }, [leadingIconProps]);
  var trailingIconProps = mapTrailingIcon(props);
  var trailingIconElement = React.useMemo(function () {
    return trailingIconProps && /*#__PURE__*/React.createElement(Icon, trailingIconProps);
  }, [trailingIconProps]);
  var labelCaptionModel = mapLabelCaption(props);
  var labelCaption = React.useMemo(function () {
    return labelCaptionModel && /*#__PURE__*/React.createElement(Typography, labelCaptionModel.typographyProps, labelCaptionModel.captionText);
  }, [labelCaptionModel]);
  var labelVariantModel = mapLabelVariant(props);
  var labelVariant = React.useMemo(function () {
    return labelVariantModel && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, labelVariantModel.boxProps, labelVariantModel.loaderProps ? /*#__PURE__*/React.createElement(DotsLoader, _extends({
      label: labelVariantModel.loaderProps.label
    }, labelVariantModel.loaderProps)) : /*#__PURE__*/React.createElement(React.Fragment, null, leadingIconElement, /*#__PURE__*/React.createElement(Typography, labelVariantModel.typographyProps, labelVariantModel.typographyChildren), !leadingIconElement && trailingIconElement)));
  }, [labelVariantModel, leadingIconElement, trailingIconElement]);
  var iconVariantModel = mapIconVariant(props);
  var iconVariant = React.useMemo(function () {
    if (!iconVariantModel) return undefined;
    return iconVariantModel.loaderProps ? /*#__PURE__*/React.createElement(RadialLoaderMemoized, _extends({
      label: iconVariantModel.loaderProps.label
    }, iconVariantModel.loaderProps)) : leadingIconElement;
  }, [iconVariantModel, leadingIconElement]);
  var containerBoxModel = mapContainerBox(props);
  var content = /*#__PURE__*/React.createElement(Box, _extends({
    "aria-label": containerBoxModel.ariaLabel,
    ref: ref
  }, isUnderGroup && {
    className: 'child-group'
  }, containerBoxModel.boxProps), labelVariant, labelCaption, iconVariant);
  return content;
});
Button.defaultProps = defaultProps;
var ButtonWithRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    ref: ref
  }));
});
ButtonWithRef.displayName = 'Button';
var ButtonMemoized = /*#__PURE__*/React.memo(ButtonWithRef);
ButtonMemoized.displayName = 'Button';

export { Button as BaseButton, ButtonMemoized as Button };
//# sourceMappingURL=Button.js.map
